import { get, writable } from "svelte/store";

function createUserListStore() {
    const openedUserListStore = writable(false);
    const { subscribe, set } = openedUserListStore;

    return {
        subscribe,
        toggle() {
            set(!get(openedUserListStore));
        },
        open() {
            set(true);
        },
        close() {
            set(false);
        },
    };
}

export const userListStore = createUserListStore();

// Tracks which user action menu is currently open (by user id); null = all closed
export const activeUserActionMenuStore = writable<string | null>(null);
